import React from "react";
import Button from "@mui/material/Button";

interface VerifikasiEmailActionProps {
    onBackToLogin: () => void;
}

const VerifikasiEmailAction = ({
    onBackToLogin,
}: VerifikasiEmailActionProps) => {
    return (
        <Button variant="contained" onClick={onBackToLogin}>
            Kembali ke Login
        </Button>
    );
};

export default VerifikasiEmailAction;
